import { relayablyDarkTheme, relayablyLightTheme, Theme } from '@monorepo/relayably/theme'
import { SafeAreaView, StatusBar, StyleSheet, useColorScheme, View } from 'react-native'
import { AppNavigator } from './navigation/AppNavigator'

export const AuthExperience = () => {
  const colorScheme = useColorScheme()
  const theme = colorScheme === 'dark' ? relayablyDarkTheme : relayablyLightTheme
  const styles = createStyles(theme)

  return (
    <View style={[styles.screen, { backgroundColor: theme.colors.background }]}>
      <StatusBar barStyle={theme.dark ? 'light-content' : 'dark-content'} />
      <SafeAreaView style={styles.screen}>
        <AppNavigator theme={theme} />
      </SafeAreaView>
    </View>
  )
}

const createStyles = (theme: Theme) =>
  StyleSheet.create({
    screen: {
      flex: 1,
    },
  })
